export default "/images/BC-Step-3.png?22af9f3436b2459d0c2e285ea789b678";